export const LOADING_OVERLAY_TRANSITION_MS = 300;
export const LOADING_OVERLAY_FULL_VIEWPORT_ID = 'spds-loading-overlay-full-viewport';

export default {
  LOADING_OVERLAY_FULL_VIEWPORT_ID,
  LOADING_OVERLAY_TRANSITION_MS,
};
